import React, { useContext, useEffect, useState } from 'react';
import { AppSettings } from '../../config/app-settings';
import Loader from '../pages/loader';
import ReusableTable from '../../components/other/ReuseableTable';
import { useListGroupsQuery } from '../../redux/Api/UserManagment/uMGroupsApiSlice';
import EditCreateGroups from '../../components/users/EditCreateGroups';
import { can } from '../../helpers/auth';
import NoPermission from '../pages/noPermission';
import { toast } from 'react-toastify';

function Groups() {
	const [pagination, setPagination] = useState({
		current: 1,
		pageSize: 10
	})

    const { data: groups, isLoading, error, isFetching } = useListGroupsQuery({
		page: pagination.current,
		page_size: pagination.pageSize
	})
	const [edit, setEdit] = useState(false)
	const [create, setCreate] = useState(false)
	const [holder, setHolder] = useState()

	useEffect(() => {
		if (error?.data) {
			const errorMessages = Object.values(error.data).flat()
			errorMessages.forEach(message => {
				toast.error(message)
			})
		}
	}, [error])

	let columns = [
		{ title: "ID", dataIndex: "id", key: "id", sorter: true },
		{
			title: 'Name',
			dataIndex: 'name',
			key: 'name',
			sorter: true,
			search: true,
		},

	];
	if(can("change_group")){
		columns.push({
			title: 'Actions',
			key: 'actions',
			render: (text, record) => (
				<div className='flex gap-2'>
					<button className='btn btn-outline-theme' onClick={() => handleEdit(record)}>Edit</button>
				</div>
			),
		})
	}

	const handleEdit = (record) => {
		setHolder(record)
		setEdit(true)
	};

	const handleTableChange = paginationInfo => {
		setPagination({
			current: paginationInfo.current,
			pageSize: paginationInfo.pageSize
		})
	}


    const context = useContext(AppSettings);
	useEffect(() => {
		context.setAppHeaderNone(false);
		context.setAppSidebarNone(false);
		context.setAppContentClass('');
		context.setAppThemePanal(true)

		return function cleanUp() {
			context.setAppHeaderNone(true);
			context.setAppSidebarNone(true);
			context.setAppContentClass('p-0');
			context.setAppThemePanal(false)
		};
	}, []);

	if (!can("view_group")) {
        return <NoPermission />
    }
	return (
		<div className='w-full flex flex-col'>
			<Loader isLoading={isLoading || isFetching} />
			{edit ? <EditCreateGroups state={"edit"} open={edit} setOpen={setEdit} group={holder} /> : null}
			{create ? <EditCreateGroups state={"create"} open={create} setOpen={setCreate} group={null} /> : null}
			<button className='btn btn-outline-theme ml-auto' onClick={() => setCreate(true)}>Add New Groups</button>
			<br/>
			{groups ?
				<ReusableTable
					columns={columns}
					data={groups?.results}
					pagination={{
						current: pagination.current,
						pageSize: pagination.pageSize,
						total: groups?.count,
						showSizeChanger: true
					}}
					onChange={handleTableChange}
				/>
				: null
			}
		</div>
	)
}

export default Groups;
